import { render, staticRenderFns } from "./ChartPivotConfig.vue?vue&type=template&id=f289f91e&scoped=true&"
import script from "./ChartPivotConfig.vue?vue&type=script&lang=js&"
export * from "./ChartPivotConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f289f91e",
  null
  
)

export default component.exports